// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_jquery_dist_jquery_js-node_modules_lightgallery_lightgallery_es5_js-node-65f0ef"], () => (__webpack_require__("./wp-content/themes/martfuspa/assets/js/master.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
